import React from 'react'
import Box from '../../components/Box'
import styles from '../home/Home.module.css';

function Online({ liveData }) {
	const todoTiles = [];

	// Dynamically build the values object from incoming data
	const values = {};


	for (let i = 0; i < liveData.crawler.length; i++) {
		const proxy = liveData.crawler[i];
		if (!values[proxy.proxy_location]) {
			values[proxy.proxy_location] = {1: 0, 2: 0};
		}
		values[proxy.proxy_location][proxy.todo_type] = proxy.count;
	}

	Object.keys(values).forEach((key) => {
		todoTiles.push({
			title: key + ' - Pages',
			value: values[key][1],
			change: '↓100%',
			description: 'Last updated at 16:14',
			property: '',
		});
		todoTiles.push({
			title: key + ' - Articles',
			value: values[key][2],
			change: '↓100%',
			description: 'Last updated at 16:14',
			property: '',
		});
	});

	
	const tilesData = [
		...todoTiles,
		{ title: 'Insert Todo Link', value: liveData.rabbit['insert_todolink'], change: '↓100%', description: 'Last updated at 16:14', property: '' },
		{ title: 'Mine Headlines', value: liveData.rabbit['crawler_mine_headlines'], change: '↓100%', description: 'Last updated at 16:14', property: '' },
		{ title: 'Crawler Parser', value: liveData.rabbit['crawler_parser'], change: '↓100%', description: 'Last updated at 16:14', property: '' },
		{ title: 'AI Crawler Parser', value: liveData.rabbit['crawler_ai_parser'], change: '↓100%', description: 'Last updated at 16:14', property: '' },
		{ title: 'AI Crawler Parser Retry', value: liveData.rabbit['crawler_ai_parser_retry'], change: '↓100%', description: 'Last updated at 16:14', property: '' },
		{ title: 'Forum Todo Link', value: liveData.rabbit['forum_queue_todolink'], change: '↓100%', description: 'Last updated at 16:14', property: '' },
		{ title: 'Forum Parser', value: liveData.rabbit['forum_queue_parser'], change: '↓100%', description: 'Last updated at 16:14', property: '' },
		{ title: 'Forum Mine Headlines', value: liveData.rabbit['forum_queue_mineheadlines'], change: '↓100%', description: 'Last updated at 16:14', property: '' },
		{ title: 'Forum Insert Pagination and Comments', value: liveData.rabbit['forum_queue_insert_pagination_and_comments'], change: '↓100%', description: 'Last updated at 16:14', property: '' },
		{ title: 'Generate Syndication', value: liveData.rabbit['crawler_generate_syndication'], change: '↓100%', description: 'Last updated at 16:14', property: '' },
	];

	return (
		<div className={styles.dashboard}>
			{tilesData.map((tile, index) => (
				<Box key={index} tile={tile} />
			))}
		</div>
	);
}

export default Online